// VFX: Window Rain Streaks
// Category: overlays · Tags: rain, window, weather, glass, droplets
// Procedural rain streaks on glass with beading droplets and gravity trails.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, random } from "remotion";
import React from "react";

const DROPLET_COUNT = 60;
const STREAK_COUNT = 18;

export default function FxRainWindowStreaksLoop() {
  const frame = useCurrentFrame();
  const { height } = useVideoConfig();

  return (
    <AbsoluteFill style={{
      background: "linear-gradient(180deg, #1e293b 0%, #0f172a 50%, #0a0e1a 100%)",
      overflow: "hidden",
    }}>
      {/* Soft blurred backdrop city lights */}
      {Array.from({ length: 24 }).map((_, i) => (
        <div key={`bg-${i}`} style={{
          position: "absolute",
          left: `${(i * 41) % 100}%`,
          top: `${(i * 23 + 30) % 90}%`,
          width: 80, height: 80, borderRadius: "50%",
          background: ["#06b6d4", "#a855f7", "#f97316"][i % 3],
          opacity: 0.18,
          filter: "blur(40px)",
        }} />
      ))}

      {/* Gravity streaks */}
      {Array.from({ length: STREAK_COUNT }).map((_, i) => {
        const x = (i * 311) % 100;
        const speed = 1.5 + random(`sp-${i}`) * 2;
        const yStart = -200 + ((frame * speed + i * 200) % (height + 400));
        const len = 60 + random(`l-${i}`) * 140;
        return (
          <div key={`st-${i}`} style={{
            position: "absolute",
            left: `${x}%`, top: yStart,
            width: 2, height: len,
            background: "linear-gradient(180deg, transparent 0%, rgba(186,230,253,0.6) 70%, rgba(255,255,255,0.9) 100%)",
            borderRadius: 2,
            filter: "blur(0.6px)",
          }} />
        );
      })}

      {/* Beading droplets on glass (static) */}
      {Array.from({ length: DROPLET_COUNT }).map((_, i) => {
        const x = random(`dx-${i}`) * 100;
        const y = random(`dy-${i}`) * 100;
        const size = 4 + random(`ds-${i}`) * 10;
        const shimmer = 0.4 + Math.sin(frame * 0.05 + i) * 0.15;
        return (
          <div key={`d-${i}`} style={{
            position: "absolute",
            left: `${x}%`, top: `${y}%`,
            width: size, height: size, borderRadius: "50%",
            background: "radial-gradient(circle at 35% 35%, rgba(255,255,255,0.85) 0%, rgba(186,230,253,0.4) 50%, transparent 80%)",
            opacity: shimmer,
            boxShadow: "inset 0 -1px 2px rgba(0,0,0,0.3)",
          }} />
        );
      })}

      {/* Glass tint overlay */}
      <AbsoluteFill style={{
        background: "linear-gradient(180deg, rgba(15,23,42,0.3) 0%, rgba(15,23,42,0.1) 100%)",
        backdropFilter: "blur(1px)",
      }} />
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
